module.exports = __webpack_public_path__ + "img/alatIcon.901cabff.svg";